/** Formats a whole number of minutes as e.g. "2 hr 30 min", "45 min" or "3 hr". */
export function formatDuration(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) {
    return `${String(minutes)} min`;
  }
  if (minutes === 0) {
    return `${String(hours)} hr`;
  }
  return `${String(hours)} hr ${String(minutes)} min`;
}
